export const LSPMFilterOptions = [
    {
        id: "situational_total",
        label: "Situational Average",
    },
    {
        id: "situation_value_crystallisation_depth",
        label: "Value Crystallisation Depth",
    },
    {
        id: "situation_value_crystallisation_breadth",
        label: "Value Crystallisation Breadth",
    },
    {
        id: "situation_acquisitions_tactical",
        label: "Tactical M&A",
    },
    {
        id: "situation_acquisitions_strategic",
        label: "Strategic M&A",
    },
    {
        id: "domain_total",
        label: "Domain Average",
    },
    {
        id: "domain_depth",
        label: "Domain Depth",
    },
    {
        id: "domain_breadth",
        label: "Domain Breadth",
    },
    {
        id: "domain_capital_structure",
        label: "Capital Structure",
    },
    {
        id: "domain_scale",
        label: "Scale",
    },
    {
        id: "function_total",
        label: "Functional Average",
    },
    {
        id: "function_depth ",
        label: "Functional Depth",
    },
    {
        id: "function_breadth",
        label: "Functional Breadth",
    },
    {
        id: "function_responsibility",
        label: "Level of Responsibility",
    },
    {
        id: "function_route",
        label: "Functional Route",
    },
    {
        id: "behaviour_pragmatism",
        label: "Pragmatism",
    },
    {
        id: "behaviour_agility",
        label: "Agility",
    },
    {
        id: "behaviour_curiosity",
        label: "Curiosity",
    },
    {
        id: "behaviour_execution",
        label: "Execution",
    },
    {
        id: "behaviour_total",
        label: "Behaviour Average",
    },
    {
        id: "internationalisation",
        label: "Internationalisation",
    },
];
